import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { IUnitList } from '../../../utils/interfaces/unit';

import { ActivatedRoute } from '@angular/router';
import QRCode from 'qrcode';
import { environment } from '../../../../environments/environment';
import { LoadingService } from '../../../shared/services/loading.service';
import { UnitsService } from '../../../shared/services/units.service';

interface IDocumentList {
  name: string;
  url: string;
  urlQAS: string;
  urlProd: string;
  img: boolean;
  urlSmallImg: string;
  horizontal: boolean;
  qrSize: number;
  x: number;
  y: number;
}

/**
 * @description
 * Template for QR Code as imagens são adicionadas no storage e passadas para adicionarmos no template
 */
const templateForQRCode: IDocumentList[] = [
  {
    name: 'A4_Vertical',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/d2747ce4-84a0-4524-95ff-e4b228e08dbc_A4_Vertical.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/5fd98773-8ed4-4563-b836-fd1bc0f3c881_A4_Vertical.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/cb932946-5cd7-4500-b179-cdef05256a1c_A4_Vertical.jpg',
    urlSmallImg: 'A4_Vertical - Copia.jpg',
    img: true,
    horizontal: true,
    qrSize: 513,
    x: 194,
    y: 2500,
  },
  {
    name: 'Banner',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/aa58da72-5639-48f1-a9ab-e0511693ca44_Banner.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/72c29bb4-535c-4dbd-86dc-85530acd1c74_Banner.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/a6b43362-59d6-43a9-b61f-c0418365eda2_Banner.jpg',
    urlSmallImg: 'Banner - Copia.jpg',
    img: true,
    horizontal: true,
    qrSize: 1840,
    x: 640,
    y: 10997,
  },
  {
    name: 'Display de mesa_7 x 11 cm',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/cffc5593-2d30-4a23-af75-3a9a56d82c26_Displaydemesa_7x11cm.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/c8078ab3-6465-4470-80c4-3c18fa9222da_Displaydemesa_7x11cm.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/33b27fbc-0f0c-452b-a663-17783522ca14_Displaydemesa_7x11cm.jpg',
    urlSmallImg: 'Display de mesa_7 x 11 cm - Copia.jpg',
    img: true,
    horizontal: true,
    qrSize: 168,
    x: 61,
    y: 1007,
  },
  {
    name: 'Emkt',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/e1235881-9666-482d-8d0a-3d3004772d67_Emkt.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/ae4e7954-3b67-4bad-89d7-dd3b2d75684d_Emkt.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/fded86d3-9812-4933-b92e-565eddd2c76f_Emkt.jpg',
    urlSmallImg: 'Emkt - Copia.jpg',
    img: true,
    horizontal: true,
    qrSize: 500,
    x: 152,
    y: 2591,
  },
  {
    name: 'TV_Vertical',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/8f181a19-ed61-4619-8d47-b406f65ecd74_TV_Vertical.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/1a2fb605-244a-4bd3-bc58-cc53fa31e868_TV_Vertical.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/07058fdd-a612-41b3-83a9-1a349197603d_TV_Vertical.jpg',
    urlSmallImg: 'TV_Vertical - Copia.jpg',
    img: true,
    horizontal: true,
    qrSize: 1132,
    x: 1806,
    y: 5540,
  },
  {
    name: 'TV_Horizontal',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/3edb6b1d-e333-455f-b6ae-bba538e0f376_TV_Horizontal.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/11a2b53f-0b79-413e-90ac-4ba31d88ab9e_TV_Horizontal.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/675fb836-614a-4048-9a94-c7bca3bb8c30_TV_Horizontal.jpg',
    urlSmallImg: 'TV_Horizontal - Copia.jpg',
    img: true,
    horizontal: false,
    qrSize: 1040,
    x: 5892,
    y: 2290,
  },
  {
    name: 'A4_Horizontal',
    url: 'https://api-saporeconecta-dev.sapore.com.br/static/newsurvey-imgs/06338df3-b823-41e4-97ff-a4d2c39e32ef_A4_Horizontal.jpg',
    urlQAS:
      'https://api-saporeconecta-qas.sapore.com.br/static/newsurvey-imgs/ada3ba6d-b589-456b-a989-7b7fbfb3d95b_A4_Horizontal.jpg',
    urlProd:
      'https://api-saporeconecta.sapore.com.br/static/newsurvey-imgs/cc86e7c4-da1b-4e25-8cf8-62b03c37d9b5_A4_Horizontal.jpg',
    urlSmallImg: 'A4_Horizontal - Copia.jpg',
    img: true,
    horizontal: false,
    qrSize: 434,
    x: 2687,
    y: 1438,
  },
];

@Component({
  selector: 'app-qr-code',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent implements OnInit, OnDestroy {
  readonly URI_API = environment.apiConfig.uri;
  private readonly unitsService = inject(UnitsService);
  private readonly loadingService = inject(LoadingService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly unsubscribe$ = new Subject();
  searchText = new FormControl({ value: '', disabled: false });

  unit!: IUnitList;
  loadUnits = false;
  units: IUnitList[] = [];

  documentList: IDocumentList[] = templateForQRCode;

  userWithABranch = true;

  ngOnInit(): void {
    this.unit = this.activatedRoute.snapshot.data['unit']?.data ?? undefined;
    if (this.unit) {
      this.searchText.disable();
    }

    this.searchText.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .pipe(debounceTime(700))
      .subscribe(() => {
        if (this.searchText.value) this.getUnits();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  getUnits(): void {
    this.loadingService.showLoading();
    this.loadUnits = true;

    this.unitsService
      .getUnitsWithAccess(this.searchText.value!)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          this.units = response.data;
          this.loadUnits = false;
          this.loadingService.closeLoading();
        },
      });
  }

  async downloadImageWithQrCode(doc: IDocumentList): Promise<void> {
    this.loadingService.showLoading();

    // Buscar a imagem do blob, ajustar se precisar guardar na pasta assets
    const imageResponse = await fetch(
      `${
        this.URI_API.includes('qas')
          ? doc.urlQAS
          : this.URI_API.includes('dev')
          ? doc.url
          : doc.urlProd
      }`
    );
    const imageBlob = await imageResponse.blob();
    const img = new Image();

    img.onload = async () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) return;

      // Ajustar o tamanho do canvas
      canvas.width = img.width;
      canvas.height = img.height;

      // Desenhar a imagem original no canvas
      ctx.drawImage(img, 0, 0);

      // Gerar QR Code como imagem base64
      const qrCodeDataUrl = await QRCode.toDataURL(
        `${environment.urlQRCode}${this.unit.shortBranch}`
      );

      const qrImg = new Image();
      qrImg.onload = () => {
        // Desenhar o QR Code na posição desejada
        ctx.drawImage(qrImg, doc.x, doc.y, doc.qrSize, doc.qrSize);

        // Converter o canvas para blob e criar um link de download
        canvas.toBlob((blob) => {
          if (blob) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = doc.url; // Manter o nome do arquivo original
            link.click();
          }
          this.loadingService.closeLoading();
        }, 'image/png');
      };
      qrImg.src = qrCodeDataUrl;
    };

    img.src = URL.createObjectURL(imageBlob);
  }

  selectUnit(unit: IUnitList): void {
    this.unit = unit;

    this.searchText.reset();

    this.units = [];
  }
}
